import { apiClient, apiV2Client } from '@/services/api-client'
import type {
  AuthUser,
  ChangeStaffPasswordRequest,
  LoginRequest,
  LoginV2Response,
  LogoutRequest,
  MfaSetupData,
  NavegaStaffLoginRequest,
  NavegaStaffTokenResponse,
  RefreshRequest,
  TokenResponse,
} from '@/features/auth/types/auth.types'

export const authService = {
  login: (data: LoginRequest) => apiClient.post<TokenResponse>('/auth/login', data),

  loginV2: (data: LoginRequest) => apiV2Client.post<LoginV2Response>('/auth/login', data),

  getMfaSetup: (mfaToken: string) =>
    apiV2Client.get<MfaSetupData>('/auth/mfa/setup', { token: mfaToken }),

  verifyMfaSetup: (code: string, mfaToken: string) =>
    apiV2Client.post<TokenResponse>('/auth/mfa/setup/verify', { code }, { token: mfaToken }),

  validateMfa: (code: string, mfaToken: string) =>
    apiV2Client.post<TokenResponse>('/auth/mfa/validate', { code }, { token: mfaToken }),

  navegaStaffLogin: (data: NavegaStaffLoginRequest) =>
    apiClient.post<NavegaStaffTokenResponse>('/auth/navega/login', data),

  refresh: (data: RefreshRequest) => apiClient.post<TokenResponse>('/auth/refresh', data),

  logout: (data: LogoutRequest, token: string) =>
    apiClient.post<void>('/auth/logout', data, { token }),

  me: (token: string) => apiClient.get<AuthUser>('/auth/me', { token }),

  changeStaffPassword: (data: ChangeStaffPasswordRequest, token: string) =>
    apiClient.post<void>('/auth/navega/change-password', data, { token }),

  changeUserPassword: (currentPassword: string, newPassword: string, token: string) =>
    apiClient.patch<void>('/auth/me/password', { currentPassword, newPassword }, { token }),
}
